import { useState } from 'react';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import defaultLogo from '../../assets/images/TechForGov-logo-default.png';

const LogoWrapper = styled(Link)(({ theme }) => ({
  color: '#6E759F',
  display: 'flex',
  justifyContent: 'center',
  textDecoration: 'none',
  margin: '0 auto',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: '35px'
}));

function Logo() {
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const themeLogo = useSelector((store: RootState) => store.theme.themeLogo);
  const [imageError, setImageError] = useState(false);

  // Get the logo source - use full URL if it's a URL, otherwise use as-is
  let logoSrc = null;
  if (themeLogo && !imageError) {
    try {
      // If it's a full URL, use it directly
      if (themeLogo.startsWith('http://') || themeLogo.startsWith('https://')) {
        logoSrc = themeLogo;
      } else if (themeLogo.startsWith('/')) {
        // If it's an absolute path, use it directly
        logoSrc = themeLogo;
      } else {
        // Try to extract pathname from URL if it's a URL object
        try {
          const url = new URL(themeLogo);
          logoSrc = url.pathname;
        } catch {
          // If URL parsing fails, use the themeLogo as-is
          logoSrc = themeLogo;
        }
      }
    } catch (error) {
      // Fallback to themeLogo as-is if any error occurs
      logoSrc = themeLogo;
    }
  }

  return (
    <LogoWrapper to={`/dashboard/${userDetails.TownshipID}`} sx={{
      maxHeight: '60px',
      width: '214px',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {logoSrc && !imageError ? (
        <img 
          style={{ 
            width: "100%", 
            height: "auto",
            maxHeight: "60px",
            objectFit: "contain",
            marginTop: "7px" 
          }} 
          src={logoSrc} 
          alt="logo"
          onError={() => {
            // Fallback to default logo if image fails to load
            setImageError(true);
          }}
        />
      ) : (
        <img 
          style={{ 
            width: "100%", 
            height: "auto",
            maxHeight: "60px",
            objectFit: "contain",
            marginTop: "7px" 
          }} 
          src={defaultLogo} 
          alt="TechForGov logo"
        />
      )}
    </LogoWrapper>
  );
}

export default Logo;
